import { ReactNode } from "react";

import PromptDark from "../svgs/prompt/PromptDark";
import PromptDarkAlt from "../svgs/prompt/PromptDarkAlt";
import PromptGlossy from "../svgs/prompt/PromptGlossy";
import PromptGlossyAlt from "../svgs/prompt/PromptGlossyAlt";
import PromptLight from "../svgs/prompt/PromptLight";
import PromptLightAlt from "../svgs/prompt/PromptLightAlt";

import { useTheme } from "~app/providers/ThemeProvider";
import clsx from "clsx";

export const ChippyPromptImage = ({
  alternative,
}: {
  alternative?: boolean;
}) => {
  const { theme } = useTheme()!;
  let ChippyPromptImage;

  const PromptWindow98 = () => (
    // eslint-disable-next-line @next/next/no-img-element
    <img className="prompt-image" alt="Windows 98 image" src="/window98.png" />
  );

  switch (theme) {
    case "dark":
      ChippyPromptImage = alternative ? PromptDarkAlt : PromptDark;
      break;
    case "light":
      ChippyPromptImage = alternative ? PromptLightAlt : PromptLight;
      break;
    case "glossy":
      ChippyPromptImage = alternative ? PromptGlossyAlt : PromptGlossy;
      break;

    default:
      ChippyPromptImage = PromptWindow98;
      break;
  }

  return <ChippyPromptImage />;
};

export default function ChippyPromptWrapper({
  children,
}: {
  children: ReactNode;
}) {
  const { theme } = useTheme();

  return (
    <div
      className={clsx("hero-wrapper", {
        clippybg: theme === "window98",
      })}
    ></div>
  );
}
